import { render } from "./jsSeamlessScroll.vue?vue&type=template&id=7f4bdcd5"
import script from "./jsSeamlessScroll.vue?vue&type=script&lang=js"
export * from "./jsSeamlessScroll.vue?vue&type=script&lang=js"
script.render = render

export default script